/**
 * Application Store
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules
})



// WEBPACK FOOTER //
// ./src/store/store.js